var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74987 10.0001H4.16653M4.09599 10.243L2.15022 16.0552C1.99736 16.5119 1.92093 16.7402 1.97578 16.8808C2.02341 17.0029 2.12571 17.0954 2.25195 17.1307C2.39731 17.1712 2.61687 17.0724 3.05598 16.8748L16.9822 10.608C17.4108 10.4151 17.6251 10.3187 17.6913 10.1847C17.7489 10.0684 17.7489 9.93179 17.6913 9.8154C17.6251 9.68143 17.4108 9.585 16.9822 9.39212L3.05112 3.12317C2.61334 2.92617 2.39444 2.82767 2.24922 2.86807C2.12311 2.90317 2.02082 2.99549 1.97302 3.11736C1.91798 3.25769 1.9936 3.4855 2.14482 3.94113L4.09653 9.82134C4.1225 9.8996 4.13549 9.93873 4.14062 9.97874C4.14517 10.0143 4.14512 10.0502 4.14048 10.0857C4.13525 10.1257 4.12216 10.1648 4.09599 10.243Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChat);
export default __webpack_public_path__ + "static/media/sendChat.40ee17f41ab8f8549c3c4e3c86e816d9.svg";
export { ForwardRef as ReactComponent };